<template>
    <div>
        <div class="card">
            <div class="col-12 row p-3 ml-0">
                <!-- <div class="col-4">
                    <button class="btn btn-secondary">10 Dias</button>
                </div>
                <div class="col-4">
                    <button class="btn btn-secondary">15 Dias</button>
                </div>
                <div class="col-4">
                    <button class="btn btn-secondary">30 Dias</button>
                </div> -->

                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Placa</th>
                            <th scope="col">Horas Trabalhadas</th>
                            <th scope="col">Data</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in items" :key="item.nr_sequencial">
                            <th scope="row">{{ item.nr_placa }}</th>
                            <th scope="row">{{ item.diferenca}}</th>
                            <th scope="row">{{ item.dt_os | formatDate("DD/MM/YYYY") }}</th>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="card">

            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            items: [],
            horasOs: ''
        }
    },
    created() {
        this.getOsMecanico()
        console.log(this.items)
    },
    methods: {
        getOsMecanico() {
            const mecanico = this.$store.getters['filial/filial']

            this.$store.dispatch('colaborador/getOsMecanico', { idMecanico: mecanico.tecnicoId }).then(response => {
                response.data.forEach(element => {
                    let data_inicial = new Date(element.dt_inicial)
                    let data_final = new Date(element.dt_final)
                    let diferenca = new Date(data_final - data_inicial)
                    var resultado = ("00" + diferenca.getUTCHours()).slice(-2) + ":"
                    resultado += ("00" + diferenca.getUTCMinutes()).slice(-2) + ":";
                    resultado += ("00" + diferenca.getUTCSeconds()).slice(-2) + "";

                    element.diferenca = resultado
                    this.items.push(element)
                });
                // this.items = response.data[0].execucoes_iniciadas
            })
        }
    }
}
</script>